import enUS from './en-US.json'
import zhCN from './zh-CN.json'

export const messages = {
  'en-US': enUS,
  'zh-CN': zhCN,
}

export type Locale = keyof typeof messages

export const defaultLocale: Locale = 'en-US'

export const supportedLocales: Locale[] = Object.keys(messages) as Locale[]
